import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route pathname change, but NOT on language-only change
// (e.g. /ar -> /en with same rest of path).
export default function useScrollToTop() {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    const prev = prevPathRef.current;
    const curr = location.pathname;

    // Split into segments
    const prevSeg = prev.split("/").filter(Boolean);
    const currSeg = curr.split("/").filter(Boolean);

    // Language switch: same tail, only first segment (lang) differs
    const isLangSwitch =
      prevSeg.length === currSeg.length &&
      prevSeg.length >= 1 &&
      ((prevSeg[0] === "ar" && currSeg[0] === "en") ||
        (prevSeg[0] === "en" && currSeg[0] === "ar")) &&
      prevSeg.slice(1).join("/") === currSeg.slice(1).join("/");

    if (!isLangSwitch) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
    prevPathRef.current = curr;
  }, [location.pathname]);
}
